module.exports = __webpack_public_path__ + "img/QuentinVeillas.be3871a7.gif";